import { getCookieConsent } from './analytics';

export const POST_CASTING_ROUTE = '/casting-calls/new';

export const POST_CASTING_ROLES = Object.freeze([
  'casting_professional',
  'production_company',
]);

export const POST_CASTING_CTA_EVENT = 'post_casting_cta_click';

const VALID_SURFACES = new Set([
  'header',
  'profile_menu',
  'mobile_menu',
  'dashboard',
]);

export function canShowPostCastingCta(activeRole) {
  return POST_CASTING_ROLES.includes(activeRole);
}

export function trackPostCastingCta(surface, activeRole) {
  if (typeof window === 'undefined') return;
  if (!VALID_SURFACES.has(surface)) return;
  if (!canShowPostCastingCta(activeRole)) return;

  const consent = getCookieConsent();
  if (!consent?.analytics) return;

  const properties = {
    surface,
    active_role: activeRole,
  };

  try {
    window.gtag?.(
      'event',
      POST_CASTING_CTA_EVENT,
      properties,
    );
  } catch {
    // Analytics must never block navigation.
  }

  try {
    window.posthog?.capture?.(
      POST_CASTING_CTA_EVENT,
      properties,
    );
  } catch {
    // Analytics must never block navigation.
  }
}